export default __webpack_public_path__ + "static/media/propic-round.773645b3.png";